import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import transformComparisonV4Response from '../resources/clients/quotes/transformComparisonV4Response';
import { calculateSavingsWithRespectToWiseQuote } from '../resources/savingsCalculator';
import { Table } from '../resources/tracking/types';
import getFastestProviders from './utils/getFastestProviders';
// Create the context
const ComparisonTableHeroV2TableTrackingContext = createContext(undefined);
export function useComparisonTableHeroV2TableTrackingContext() {
    const context = useContext(ComparisonTableHeroV2TableTrackingContext);
    if (!context) {
        throw new Error('useComparisonTableHeroV2TableTrackingContext must be used within a ComparisonTableHeroV2TableTrackingContextProvider');
    }
    const quotes = useMemo(() => transformComparisonV4Response(context.trackingData.comparisonResponse, context.trackingData.excludePartners), [context.trackingData]);
    const cheapestProviderAliases = useMemo(() => {
        const sortedQuotes = quotes.sort((a, b) => b.receivedAmount.value - a.receivedAmount.value);
        const cheapestProviders = quotes.filter((quote) => quote.receivedAmount === sortedQuotes[0].receivedAmount);
        return cheapestProviders.map((quote) => quote.provider.alias);
    }, [quotes]);
    const fastestProviderAliases = useMemo(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return getFastestProviders(quotes);
    }, [quotes]);
    const trackingContext = useMemo(() => ({
        amount: context.trackingData.comparisonResponse.amount,
        source: context.trackingData.comparisonResponse.sourceCurrency,
        target: context.trackingData.comparisonResponse.targetCurrency,
        quotes: quotes,
        componentType: Table.HeroV2,
        savingsAgainstWise: calculateSavingsWithRespectToWiseQuote(quotes, context.trackingData.excludePartners),
        midMarketRate: { rate: context.trackingData.midMarketRate },
        cheapestProviders: cheapestProviderAliases,
        fastestProviders: fastestProviderAliases,
        isWiseTheCheapest: cheapestProviderAliases.filter((alias) => alias === 'wise').length > 0,
        isWiseTheFastest: fastestProviderAliases.filter((alias) => alias === 'wise').length > 0,
    }), [
        cheapestProviderAliases,
        context.trackingData.comparisonResponse.amount,
        context.trackingData.comparisonResponse.sourceCurrency,
        context.trackingData.comparisonResponse.targetCurrency,
        context.trackingData.excludePartners,
        context.trackingData.midMarketRate,
        fastestProviderAliases,
        quotes,
    ]);
    return { trackingContext, trackEvent: context.trackEvent };
}
// Create a provider component for the context
export const ComparisonTableHeroV2TableTrackingContextProvider = ({ children, trackingData, trackEvent, }) => {
    return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    _jsx(ComparisonTableHeroV2TableTrackingContext.Provider, Object.assign({ value: { trackingData, trackEvent } }, { children: children })));
};
